<template>
  <section class="flex flex-col gap-5">
    <form
      @submit.prevent="submitInfo()"
      class="grid grid-cols-12 gap-x-5 text-black"
      autocomplete="off"
    >
      <div class="flex justify-between items-center col-span-12">
        <h4>{{ $t("objectives.titles.info") }}</h4>
        <Button
          id="btn-save"
          :label="$t('labels.generic', { pt: 'Salvar', en: 'Save' })"
          type="submit"
          class="btn-primary p-button-sm"
          :loading="loading"
        />
      </div>

      <div class="my-4 col-span-12">
        <p class="mb-2">
          {{
            $t("labels.generic", { pt: "Nome do capítulo", en: "Chapter name" })
          }}
        </p>
        <InputText
          id="chapter-name-input"
          type="text"
          name="name"
          v-model="infoData.name"
          :class="v$.infoData.name.$error ? 'p-invalid' : ''"
          :maxlength="50"
        />
        <Errors
          :errors="v$.infoData.name.$errors"
          :actualLength="infoData.name?.length"
          :maxLength="50"
        />
      </div>
      <div class="flex flex-col col-span-12">
        <p class="mb-2">
          {{
            $t("labels.generic", {
              pt: "Data de início (Opcional)",
              en: "Start date (Optional)",
            })
          }}
        </p>
        <Calendar
          inputId="chapter-startdate-input"
          v-model="infoData.startDate"
          dateFormat="dd/mm/yy"
          :manualInput="false"
          :minDate="today"
          showIcon
        />
      </div>
      <div class="my-4 col-span-12 mt-9">
        <p class="mb-2">{{ $t("objectives.inputs.description") }}</p>
        <Textarea
          id="chapter-description-input"
          :autoResize="true"
          rows="10"
          cols="30"
          v-model="infoData.description"
          :maxlength="999"
        />
      </div>
    </form>
  </section>
</template>

<script lang="ts">
import { required } from "@/locale/locale.config";
import { GoToRoute } from "@/utils/go-to.util";
import {
  getItemLocalStorage,
  removeItemLocalStorage,
} from "@/utils/save-storage.util";
import useVuelidate from "@vuelidate/core";
import { PropType, defineComponent } from "vue";
import { ObjectiveService } from "../objective.service";
import { Chapter } from "@/models/chapter.model";
import { ChaptersRest } from "@/services/rest/chapters.rest";

export default defineComponent({
  name: "formInfo",
  emits: ["onNext", "onAllow", "onGetCourseById"],

  computed: {
    rest(): ChaptersRest {
      return new ChaptersRest();
    },

    service(): ObjectiveService {
      return new ObjectiveService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  props: {
    role: [String],
    predecessorId: {
      type: String,
      default: "",
    },
    chapter: {
      type: Object as PropType<Chapter>,
      default: "",
    },
  },
  data() {
    return {
      loading: false as boolean,
      today: new Date() as Date,
      autocomplete: {
        sugestions: [] as any,
        selected: null as any,
      },
      params: {
        courseId: this.$route.params.courseId,
        chapterId: this.$route.params.chapterId,
        tab: 1,
      },
      infoData: {} as Chapter,
      objectiveClicked: "",
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      infoData: {
        name: { required },
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  watch: {
    $route() {
      removeItemLocalStorage("length");
    },
  },
  methods: {
    getInfo(): void {
      const chapterId: any = this.$route.params.chapterId;
      if (chapterId && this.chapter) {
        this.infoData = this.chapter;
        this.infoData.startDate = this.infoData.startDate
          ? new Date(this.infoData.startDate)
          : null;
      }
    },
    submitInfo(): void {
      this.v$.infoData.$touch();
      if (this.params.chapterId) {
        this.$emit("onNext", 1);
        this.$emit("onAllow", 0);
      }
      if (!this.v$.infoData.$error) {
        this.loading = true;
        const data = {
          course: String(this.params.courseId),
          description: this.infoData?.description ?? "",
          name: this.infoData?.name ?? "",
          predecessorId: this.infoData.predecessorId ?? this.getPredecessor(),
          startDate: this.infoData?.startDate ?? "",
        };
        if (this.infoData.id) {
          this.update(data);
        } else {
          this.create(data);
        }
      }
    },
    create(data: any): void {
      this.rest.postTraditionalChapter(data.course, data).subscribe({
        next: (response) => {
          this.nextStep(response?.id);
        },
        error: (error) => {},
      });
    },
    update(data: any): void {
      this.rest.updateChapter(data.course, this.infoData.id, data).subscribe({
        next: (response) => {
          this.nextStep(response?.id);
        },
        error: (error) => {},
      });
    },
    nextStep(id?: any): void {
      this.params.chapterId = id;
      this.$emit("onNext", 1);
      this.$emit("onAllow", 0);
      this.go.redirectToPage("formChapterTraditional", this.params);
      this.$emit("onGetCourseById");
      this.loading = false;
    },
    getPredecessor(): string {
      let result = "";
      const course = JSON.parse(getItemLocalStorage("course"));
      if (course.chapters.length > 0) {
        result = course.chapters[course.chapters.length - 1].id;
      }
      return result;
    },
  },
});
</script>
